/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";

import { Button } from "arv-reactcomponents";
import { readCookie, isMybagCheckout } from "../../../../utils";
import { ROUTE_PATHS, LOGOUT_REDIRECT_PATHS } from "npmlinks-constants";
import Analytics, { GTM } from "../../../../analytics";
import Anchor from "../../../Anchor";
import Event from "../../../../analytics/eventFactory";

@inject("LoginStore", "MybagStore", "CommonStore")
@observer
class Login extends Component {
  static trackLoginClick() {
    Analytics.trackEvent({
      action: Event.action.LOGIN_CLICK,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_MENU_NAVIGATION,
    });
  }

  constructor() {
    super();
    this.showLoginModal = this.showLoginModal.bind(this);
    this.logout = this.logout.bind(this);
  }

  @computed
  get firstName() {
    const firstName = this.props.LoginStore.firstName;
    return readCookie("userName") || firstName;
  }

  get isHideLoginItem() {
    const { isDesktop } = this.props.CommonStore;
    return !isDesktop && isMybagCheckout() ? "nwc-hide" : "";
  }

  showLoginModal() {
    this.props.LoginStore.setloginModal(true);
    Login.trackLoginClick();
    GTM.pushEvent(Event.GTMEvent.LOGIN_CLICKED);
  }

  get dropDownClass() {
    return this.props.className ? "nw-login-hover-dropdown" : "";
  }

  logout() {
    this.props.LoginStore.logoutAction();
    this.props.MybagStore.clearCart();
    if (LOGOUT_REDIRECT_PATHS.includes(window.pageType)) {
      window.location = "/";
    }
  }

  render() {
    const { className, text } = this.props;
    return (
      <div
        className={`nw-topbar-login ${className}`}
        onClick={this.setTopDownArrow}
      >
        {this.props.LoginStore.isUserLoggedIn ? (
          <div className="nw-login-name">
            <i className="icomoon-person1 nw-lname-ico" />
            <span className={`nw-topbar-login-links ${this.isHideLoginItem}`}>
              {this.firstName}&nbsp;
            </span>
            <i className="icomoon-arrow_top nw-lname-ico nw-arrow-top" />
            <i className="icomoon-arrow_bottom nw-lname-ico nw-arrow-bottom" />
            <div className={`nw-login-hover ${this.dropDownClass}`}>
              <ul className="nw-login-hoverlist">
                <li
                  className={`nw-login-accountlist ${this.isMyabgCheckoutPage}`}
                >
                  <i className="icomoon-heart-o  nw-login-fav" />
                  <Anchor.component
                    className="nw-topbar-login-links nw-login-staticlinks"
                    href={`${ROUTE_PATHS.FAVORITES}`}
                    to={`${ROUTE_PATHS.FAVORITES}`}
                    target="_self"
                  >
                    my favourites
                  </Anchor.component>
                </li>
                <li
                  className={`nw-login-accountlist ${this.isMyabgCheckoutPage}`}
                >
                  <i className="icomoon-delivery-web nw-login-order" />
                  <Anchor.component
                    className="nw-topbar-login-links nw-login-staticlinks"
                    href={`${ROUTE_PATHS.MYORDERS}`}
                    to={`${ROUTE_PATHS.MYORDERS}`}
                    target="_self"
                  >
                    my orders
                  </Anchor.component>
                </li>
                <li
                  className={`nw-login-accountlist ${this.isMyabgCheckoutPage}`}
                >
                  <i className="icomoon-person1 nw-login-acnt" />
                  <Anchor.component
                    className="nw-topbar-login-links nw-login-staticlinks"
                    href={`${ROUTE_PATHS.ACCOUNT}`}
                    to={`${ROUTE_PATHS.ACCOUNT}`}
                    target="_self"
                  >
                    my account
                  </Anchor.component>
                </li>
                <li
                  className="nw-login-accountlist nw-login-signoutwrapper"
                  onClick={this.logout}
                >
                  <i className="icomoon-sign-out nw-login-signout" />
                  <Anchor.component
                    className="nw-topbar-login-links nw-login-staticlinks"
                    href="javascript:void(0)"
                  >
                    signOut
                  </Anchor.component>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <Button
            className={`
              nwc-btn-primary-txt
              nw-actionbuttons-btn
              nw-actionbuttons-person
              ${className}
              `}
            onClick={this.showLoginModal}
          >
            <i className="icomoon-person1" />
            <span className="nw-actionbuttons-text">{text}</span>
          </Button>
        )}
      </div>
    );
  }
}

Login.wrappedComponent.defaultProps = {
  className: "",
  text: "",
};

Login.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  MybagStore: PropTypes.shape({
    clearCart: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool,
    setloginModal: PropTypes.func.isRequired,
    logoutAction: PropTypes.func.isRequired,
    firstName: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

const getFinalComponent = component =>
  inject("LoginStore", "MybagStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Login.wrappedComponent,
  component: Login,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/ActionButtons/Login/index.js